import { combineReducers } from "redux";

import Layout from "./Layout/Layout.store";
import Notice from "./Notice/Notice.store";

const rootReducer = combineReducers({
  Layout,
  Notice,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
